import { rgba } from 'polished'
import styled from 'styled-components'

export const LastScannedWrapper = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px 8px 8px;
  background: #ffffff;
  border: 1px solid var(--color-line);
  border-radius: var(--radius-card);
`

export const LastScannedEmpty = styled.div`
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  padding: 8px 16px;
  border: 1px dashed #D5DAE0;
  border-radius: 14px;
  color: ${({ theme }) => theme.colors.muted};
`

export const LastScannedLabel = styled.div`
  font-size: 0.8125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.muted};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const thumb = `
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const LastScannedImage = styled.div`
  ${thumb}
  background: ${({ theme }) => rgba(theme.colors.primary, 0.08)};

  img {
    width: 100%;
    height: 100%;
    padding: 4px;
    object-fit: contain;
    mix-blend-mode: multiply;
  }
`

export const LastScannedIcon = styled.div`
  ${thumb}
  background: ${({ theme }) => rgba(theme.colors.primary, 0.08)};
  font-size: 1.75rem;
  line-height: 1;
`

export const LastScannedInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
`

export const LastScannedTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.global};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const LastScannedPrice = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 1.15rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.global};
`

export const LastScannedQty = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.muted};
`
